import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { ScrollContainerDataSchema, ScrollContainerUISchema } from './types'
import { SnapScrollPanel } from '../shared/SnapScrollPanel'

export function ScrollContainerContent({
  containerId,
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  containerId: string
  uiSchema: ScrollContainerUISchema
  dataSchema: ScrollContainerDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, emphasizeHeader, componentSizing = 'viewport' } = uiSchema
  const { data: components } = dataSchema
  const hasHeader = Boolean(title && tileFilters)
  return (
    <div className="flex h-full min-h-0 flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>{tileFilters}</ComponentActionsContainer>
        </ComponentHeader>
      )}
      <div className={clsx('min-h-0 flex-1', { 'pt-5': hasHeader })}>
        <SnapScrollPanel components={components} containerId={containerId} sizing={componentSizing} />
      </div>
    </div>
  )
}
